import React, {useState, useEffect, useRef} from 'react';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase/firebase';
import { useAuth } from '../contexts/authContext';
import {
    Form,
    Input,
    Button,
    Select,
    Checkbox,
    Spin,
    Alert,
    Typography,
    message,
    Card,
    Tooltip,
    Collapse
} from 'antd';
import {Link, useLocation, useNavigate} from "react-router-dom";
import ReactPlayer from "react-player";
import {setUserId} from "../config/amplitude/amplitude";

const { Option } = Select;
const { Title } = Typography;
const { Panel } = Collapse;

const DjinniConfigPage = () => {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [highlightVideo2, setHighlightVideo2] = useState(false);
    const location = useLocation();

    const video2Ref = useRef(null);

    useEffect(() => {
        document.title = 'Djinni Config - CV Postman App';
        localStorage.setItem('lastOpenedPage', '/job-config/djinni-config');
        setUserId(currentUser.email);
        // Check query parameters to see if the second video should be highlighted
        const params = new URLSearchParams(location.search);
        if (params.get("highlight") === "video2") {
            setHighlightVideo2(true);
            // Scroll to the second video after the component is mounted
            setTimeout(() => {
                video2Ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 100); // Delay to ensure the component is fully rendered
        }
    }, [location]);



    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const userEmail = currentUser.email;
                const docRef = doc(db, `users/${userEmail}/djinni.config/1`);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    const data = docSnap.data();
                    form.setFieldsValue({
                        djinniEmail: data['djinni.email'] || '',
                        djinniPassword: data['djinni.password'] || '',
                        djinniWebsite: data['djinni.website'] || 'https://djinni.co',
                        excludeCompanies: data['companies.exclude'] || '',
                        excludeWords: data['words.exclude'] || '',
                        includeWords: data['words.include'] || '',
                    });
                } else {
                    console.log("No such document!");
                }
            } catch (err) {
                console.error("Error saving data:", err);
                message.error(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (currentUser) {
            fetchData();
        }
    }, [currentUser, form]);

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            const userEmail = currentUser.email;
            const docRef = doc(db, `users/${userEmail}/djinni.config/1`);
            await setDoc(docRef, {
                'djinni.email': values.djinniEmail,
                'djinni.password': values.djinniPassword,
                'djinni.website': values.djinniWebsite,
                'companies.exclude': values.excludeCompanies || "",
                'words.exclude': values.excludeWords || "",
                'words.include': values.includeWords || "",
            });
            message.success("Saved successfully!");
            //setTimeout(() => navigate('/job-config/token-config'), 1300);
        } catch (err) {
            console.error("Error saving data:", err);
            message.error(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading}>
            <div style={{maxWidth: 600, margin: '0 auto', padding: '20px'}}>
                <Title level={3}>Djinni Configuration</Title>
                <Form
                    form={form}
                    onFinish={handleSubmit}
                    layout="vertical"
                    initialValues={{
                        djinniWebsite: 'https://djinni.co',
                    }}
                >
                    <Form.Item label="Website" name="djinniWebsite" style={{display: 'none'}}
                               rules={[{required: true, message: 'Please enter the website URL!'}]}>
                        <Input placeholder="https://djinni.co"/>
                    </Form.Item>

                    <br/>
                    <Card title="Djinni credentials:">
                        <Form.Item label="Email" name="djinniEmail"
                                   rules={[{required: true, message: 'Please enter your email!'}]}>
                            <Input placeholder="Enter your Djinni email"/>
                        </Form.Item>
                        <Form.Item label="Password" name="djinniPassword"
                                   rules={[{required: true, message: 'Please enter your password!'}]}>
                            <Input.Password placeholder="Enter your Djinni password"/>
                        </Form.Item>
                        <div style={{textAlign: 'right', marginTop: '10px'}}>
                            <Link to="/job-config/djinni-config?highlight=video2"
                                  style={{fontSize: '12px', color: '#1890ff'}}>
                                How to get djinni password (video)?
                            </Link>
                        </div>
                        <Alert
                            style={{marginTop: 16}}
                            message="Automation will Not work if you do not provide a valid password (!) of djinni.co"
                            type="info"
                        />

                    </Card>
                    <Card>
                        <Collapse defaultActiveKey={[]} ghost>
                            <Panel header="Additional filters (optional):" key="1">
                                <Tooltip title="Exclude vacancy if company name CONTAINS ANY of these words (comma seperated list)">
                                    <Form.Item label="⛔️Exclude companies" name="excludeCompanies"
                                               rules={[{required: false, message: 'Please enter companies to avoid!'}]}>
                                        <Input placeholder="SoftServe, Epam, Global Logic"/>
                                    </Form.Item>
                                </Tooltip>
                                <Tooltip title="Exclude vacancy if ANY of these words appears in job title or job description (comma seperated list)">
                                    <Form.Item label="⛔Exclude words" name="excludeWords"
                                               rules={[{
                                                   required: false,
                                                   message: 'Please enter words to avoid in the vacancy!'
                                               }]}>
                                        <Input placeholder="Angular, VueJs, iGaming, Crypto"/>
                                    </Form.Item>
                                </Tooltip>
                                <Tooltip title="Include vacancy if ANY of these words exist in the job title or job description (comma seperated list)">
                                    <Form.Item label="✅Include words" name="includeWords"
                                               rules={[{
                                                   required: false,
                                                   message: 'Please enter words to include in the vacancy!'
                                               }]}>
                                        <Input placeholder="React, ReactJs, React.Js"/>
                                    </Form.Item>
                                </Tooltip>
                            </Panel>
                        </Collapse>
                    </Card>
                    <br/><br/>
                    <Form.Item style={{ textAlign: 'center' }}>
                        <Button type="primary" htmlType="submit">
                            Save Configuration
                        </Button>
                    </Form.Item>
                </Form>
                <br/><br/><br/><br/>
                <div
                    ref={video2Ref}
                    style={{marginBottom: "20px", border: highlightVideo2 ? "2px solid #1890ff" : "none"}}
                >
                    <ReactPlayer url="https://youtu.be/e7JkChK9qrg" width="100%" controls/>
                </div>
            </div>
        </Spin>
    );
};

export default DjinniConfigPage;
